import React, { Component } from "react";
import Core from "Core";
import { Modal, Form } from "react-bootstrap";
import { observer } from "mobx-react";

class ModelEditDetail extends Component {
  render() {
    const { model } = this.props;

    return (
      <React.Fragment>
        <Modal.Body>
          <Core.Components.Alerts.ModelError model={model} />
          <Form horizontal>
            {this.props.children}
            <Core.Components.FormGroups.LastUpdatedOn
              value={model.LastUpdated}
            />
          </Form>
        </Modal.Body>
        <Core.Components.ModalParts.ModelFooterButtons model={model} />
      </React.Fragment>
    );
  }
}

export default observer(ModelEditDetail);



// WEBPACK FOOTER //
// ./src/Core/Components/ModalParts/ModelEditBody.js